/**
 * PATH: packages/email-hub/src/feature/components/email-context-menu/EmailContextMenuContent.tsx
 * FILE_ID: EMAILHUB-CONTEXTMENU-CONTENT-001
 * PURPOSE: Assembles domain action groups inside the positioned menu.
 * WHY: Makes menu ordering explicit while each group owns its behavior.
 */
import {
  ContextMenu,
  ContextMenuHeader,
} from '../../../_internal/components/ContextMenu'
import { AllocationActions } from './AllocationActions'
import { ComposeAndCopyActions } from './ComposeAndCopyActions'
import { DispositionActions } from './DispositionActions'
import { OrganizationActions } from './OrganizationActions'
import type { EmailContextMenuController } from './useEmailContextMenuController'

export function EmailContextMenuContent({
  controller,
}: {
  controller: EmailContextMenuController
}) {
  const { ctxMenu, setCtxMenu } = controller
  if (!ctxMenu) return null

  return (
    <ContextMenu
      x={ctxMenu.x}
      y={ctxMenu.y}
      onClose={() => setCtxMenu(null)}
    >
      <ContextMenuHeader>
        {ctxMenu.emailIds.length > 1
          ? `${ctxMenu.emailIds.length} emails`
          : ctxMenu.email.subject || '(no subject)'}
      </ContextMenuHeader>
      <ComposeAndCopyActions controller={controller} />
      <AllocationActions controller={controller} />
      <OrganizationActions controller={controller} />
      <DispositionActions controller={controller} />
    </ContextMenu>
  )
}
